import styled from "styled-components";

export const ContainerReg = styled.div`
    width: 92%;
    max-width: 400px;

    display: flex;
    align-items: center;
    justify-content: space-between;

    margin: 50px auto 40px;

    text-align: center;

    a {
        font-size: 12px;
        font-weight: 600;

        padding: 8px 15px;
        
        border-radius: 4px;
        
        background-color: var(--grey-3);
        color: var(--grey-0);

        transition: 0.4s;

        &:hover {
            background-color: var(--grey-2);
        }
    }
`

